document.addEventListener("DOMContentLoaded", () => {
  const hamburgerButtons = document.querySelectorAll(".header__hamburger");

  const categoryButtons = document.querySelectorAll(".header__button--corprate");
  const menuButtons = document.querySelectorAll(".header__button--menuItem");

  hamburgerButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      if (window.innerWidth < 1200) {
        const clickedElement = event.target;
        const hamburgerIcon = button.querySelector(".header__hamburger-icon");
        const isHamburgerIcon =
          clickedElement === hamburgerIcon || hamburgerIcon.contains(clickedElement);

        if (isHamburgerIcon) {
          event.stopPropagation();
          toggleHamburgerMenu();
        }
      } else {
        toggleHamburgerMenu();
      }
    });
  });

  // Add listeners to all category buttons
  categoryButtons.forEach((button) => {
    button.addEventListener("click", toggleCorporateMenu);
  });

  // Add listeners to all menu buttons
  menuButtons.forEach((button) => {
    button.addEventListener("click", toggleCategories);
  });

  // Initialize back button functionality
  toggleBackButton();

  // Initialize search functionality
  initializeSearchToggle();

  // Initialize mobile link functionality
  initializeMobileLinks();

  // Initialize logged parameter preservation
  initializeLoggedParamPreservation();
});
const productImgContainer = document.querySelector(".product-image-container");
const cartCountElement = document.getElementById("cart-count");
const hamburgerPoints = document.querySelector(".header__points");

const productCardObj = {};
const voucherCardObj = {};

// cart counter
function updateCartCount(productCardObj, voucherCardObj) {
  let totalCount = 0;
  // *logping over the product that iss added to the cart and injecting the number of items
  for (let itemId in productCardObj) {
    if (productCardObj[itemId].isAddToCart) {
      totalCount += productCardObj[itemId].numberOfItems;
    }
  }
  for (let itemId in voucherCardObj) {
    if (voucherCardObj[itemId].isAddToCart) {
      totalCount += voucherCardObj[itemId].numberOfItems;
    }
  }

  //* show if above 0
  if (totalCount > 0) {
    cartCountElement.textContent = totalCount;
    cartCountElement.style.display = "flex";
  } else {
    cartCountElement.style.display = "none";
  }
  // console.log("productCardObj", productCardObj);
}

// * make one open each time by closing the current opened menu
const closeAllMenus = (excludeSearch = false, excludePoints = false) => {
  const menus = document.querySelectorAll(
    ".header__menu--corprate, .header__menu--categories , .header__menu--hamburger, .header__menu--search"
  );
  const buttons = document.querySelectorAll(".header__button--corprate, .header__button--menuItem");
  const searchRows = document.querySelectorAll(".header__row--search");
  const searchIcons = document.querySelectorAll(".search-icon");
  const headerPoints = document.querySelectorAll(".header__points");

  menus.forEach((menu) => {
    menu.classList.remove("show");
  });

  // Only close search bar if not excluded AND (on mobile OR explicitly requested)
  if (!excludeSearch) {
    searchRows.forEach((searchRow) => {
      searchRow.style.display = "none";
    });

    searchIcons.forEach((icon) => {
      const paths = icon.querySelectorAll("path");
      paths.forEach((path) => {
        path.setAttribute("stroke", "black");
      });
    });
  } else if (window.innerWidth < 1200) {
    // On mobile, always close search even if excluded
    searchRows.forEach((searchRow) => {
      searchRow.style.display = "none";
    });

    searchIcons.forEach((icon) => {
      const paths = icon.querySelectorAll("path");
      paths.forEach((path) => {
        path.setAttribute("stroke", "black");
      });
    });
  }

  // Only hide header points if not excluded (for categories/corporate menus)
  if (!excludePoints) {
    headerPoints.forEach((points) => {
      points.style.display = "none";
    });
  }

  buttons.forEach((button) => {
    button.classList.remove("active-button");
    button.classList.remove("header--open-menu");
    const arrow = button.querySelector(".header__button-arrow");
    const arrowPath = button.querySelector(".header__button-arrow path");
    const hamburgerIcon = document.querySelector(".header__hamburger-icon");
    if (arrow) {
      arrow.classList.remove("rotate");
      arrowPath.setAttribute("stroke", "black");
      hamburgerIcon.innerHTML = `
      <path d="M3 12H21M3 6H21M9 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    `;
    }
  });
};
// ? closeAllMenus end

// * mobile and desktop hamburger menu
const toggleHamburgerMenu = () => {
  const hamburgerMenu = document.getElementById("hamburger-menu");
  const hamburgerIcons = document.querySelectorAll(".header__hamburger-icon");

  // console.log("hamburgerPoints", hamburgerPoints);

  if (hamburgerMenu.classList.contains("show")) {
    hamburgerMenu.classList.remove("show");
    // hamburgerPoints.style.display = "none";
    hamburgerIcons.forEach((icon) => {
      icon.innerHTML = `
        <path d="M3 12H21M3 6H21M9 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      `;
    });
  } else {
    closeAllMenus();
    hamburgerMenu.classList.add("show");
    const isLoggedIn = checkLoginStatus();
    if (isLoggedIn) {
      hamburgerPoints.style.display = "flex";
    } else {
      hamburgerPoints.style.display = "none";
    }
    hamburgerIcons.forEach((icon) => {
      icon.innerHTML = `
        <path d="M18 6L6 18M6 6L18 18" stroke="#4138F2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      `;
    });
  }
};
// ? mobile hamburger menu

// * toggleCategories
const toggleCategories = (event) => {
  const categoriesMenu = document.getElementById("categories-menu");
  // const clickedButton = event.target.closest(".header__button--menuItem");
  // const menuArrow = clickedButton.querySelector(".header__button-arrow");
  // const menuArrowPath = clickedButton.querySelector(".header__button-arrow path");
  if (categoriesMenu.classList.contains("show")) {
    categoriesMenu.classList.remove("show");

    document.querySelectorAll(".header__button--menuItem").forEach((button) => {
      button.classList.remove("active-button");
      button.classList.remove("header--open-menu");
      const arrow = button.querySelector(".header__button-arrow");
      const arrowPath = button.querySelector(".header__button-arrow path");
      if (arrow) {
        arrow.classList.remove("rotate");
        arrowPath.setAttribute("stroke", "black");
      }
    });
  } else {
    closeAllMenus(true, true); // excludeSearch = true, excludePoints = true for desktop
    categoriesMenu.classList.add("show");
    document.querySelectorAll(".header__button--menuItem").forEach((button) => {
      button.classList.add("active-button");
      button.classList.add("header--open-menu");
      const arrow = button.querySelector(".header__button-arrow");
      const arrowPath = button.querySelector(".header__button-arrow path");
      if (arrow) {
        arrow.classList.add("rotate");
        arrowPath.setAttribute("stroke", "white");
      }
    });
  }
  productImgContainer.style.display = "none";
};
// ? toggleCategories

//* corporate menu
const toggleCorporateMenu = (event) => {
  const corporateMenu = document.getElementById("corprate-menu");
  // const clickedButton = event.target.closest(".header__button--corprate");

  if (corporateMenu.classList.contains("show")) {
    corporateMenu.classList.remove("show");

    document.querySelectorAll(".header__button--corprate").forEach((button) => {
      button.classList.remove("active-button");
      button.classList.remove("header--open-menu");
      const arrow = button.querySelector(".header__button-arrow");
      const arrowPath = button.querySelector(".header__button-arrow path");
      if (arrow) {
        arrow.classList.remove("rotate");
        arrowPath.setAttribute("stroke", "black");
      }
    });
  } else {
    closeAllMenus(true, true);
    corporateMenu.classList.add("show");
    document.querySelectorAll(".header__button--corprate").forEach((button) => {
      button.classList.add("active-button");
      button.classList.add("header--open-menu");
      const arrow = button.querySelector(".header__button-arrow");
      const arrowPath = button.querySelector(".header__button-arrow path");
      if (arrow) {
        arrow.classList.add("rotate");
        arrowPath.setAttribute("stroke", "white");
      }
    });
  }
};
//? corporate menu
const toggleBackButton = () => {
  // const categoriesMenu = document.getElementById("categories-menu");
  // const corporateMenu = document.getElementById("corprate-menu");

  let backButtons = document.querySelectorAll(".back-button");
  const hamburgerMenu = document.getElementById("hamburger-menu");
  const hamburgerIcon = document.querySelector(".header__hamburger-icon");

  backButtons.forEach((backButton) => {
    backButton.addEventListener("click", (event) => {
      if (window.innerWidth < 1200) {
        event.preventDefault();

        closeAllMenus();

        hamburgerMenu.classList.add("show");
        hamburgerIcon.innerHTML = `
          <path d="M18 6L6 18M6 6L18 18" stroke="#4138F2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        `;
      }
    });
  });
};

// * top-middle user connection logic
const newUser = {
  hamburgerShown: "none",
  centeredOrBetween: "space-between",
  profileLink: "/?page=registration",
  profileText: "התחברות",
  closeEdgeSpace: "space-around",
  showSpecialIcon: false,
  pointsShown: "hide",
};

const connectedUser = {
  hamburgerShown: "flex",
  centeredOrBetween: "space-between",
  profileLink: "/?page=login",
  profileText: "איזור אישי",
  pointsShown: "show",
};

function updateHeader(userData) {
  const header = document.querySelector(".header");
  const corporateMenu = document.getElementById("corprate-menu");

  const mobileHamburgerElement = document.querySelector(".header__hamburger.mobile");
  const desktopHamburgerElement = document.querySelector(".header__hamburger.desktop");
  const searchRows = document.querySelectorAll(".header__row--search");

  if (header) {
    header.style.justifyContent = userData.closeEdgeSpace;
  }

  if (corporateMenu) {
    const isLoggedIn = checkLoginStatus();
    if (isLoggedIn) {
      corporateMenu.classList.add("connected");
    } else {
      corporateMenu.classList.remove("connected");
    }
  }

  searchRows.forEach((searchRow) => {
    const isLoggedIn = checkLoginStatus();
    if (isLoggedIn) {
      searchRow.classList.add("connected");
    } else {
      searchRow.classList.remove("connected");
    }
  });

  const setHamburgerVisibility = () => {
    if (window.innerWidth > 1200) {
      // if (desktopHamburgerElement) desktopHamburgerElement.style.display = userData.hamburgerShown;
      if (mobileHamburgerElement) mobileHamburgerElement.style.display = "none";
    } else {
      if (desktopHamburgerElement) desktopHamburgerElement.style.display = "none";
      // if (mobileHamburgerElement) mobileHamburgerElement.style.display = userData.hamburgerShown;
      if (mobileHamburgerElement) mobileHamburgerElement.style.display = "flex";
    }
  };

  const handleResize = () => {
    setHamburgerVisibility();
    const pointsElements = document.querySelectorAll(".header__points");
    pointsElements.forEach((pointsElement) => {
      if (pointsElement) {
        if (window.innerWidth >= 1200) {
          pointsElement.style.display = userData.pointsShown === "show" ? "flex" : "none";
        } else {
          pointsElement.style.display = userData.pointsShown;
        }
      }
    });
  };

  window.addEventListener("resize", handleResize);

  const topRowElements = document.querySelectorAll(".header__row--top");
  topRowElements.forEach((topRowElement) => {
    if (topRowElement) {
      topRowElement.style.justifyContent = userData.centeredOrBetween;
    }
  });

  const profileLinkElements = document.querySelectorAll(".header__profile");
  profileLinkElements.forEach((profileLinkElement) => {
    if (profileLinkElement) {
      const profileLink = preserveLoggedParam(userData.profileLink);
      profileLinkElement.setAttribute("href", profileLink);
      const profileTextElement = profileLinkElement.querySelector(".header__profile-text");
      if (profileTextElement) {
        profileTextElement.textContent = userData.profileText;

        if (userData.profileText === "איזור אישי") {
          profileTextElement.classList.add("logged-in");
        } else {
          profileTextElement.classList.remove("logged-in");
        }

        console.log("Profile text set:", userData.profileText, profileTextElement);
      }
    }
  });

  setHamburgerVisibility();

  const pointsElements = document.querySelectorAll(".header__points");
  pointsElements.forEach((pointsElement) => {
    if (pointsElement) {
      if (window.innerWidth >= 1200) {
        pointsElement.style.display = userData.pointsShown === "show" ? "flex" : "none";
      } else {
        pointsElement.style.display = userData.pointsShown;
      }
    }
  });
}

function checkLoginStatus() {
  const params = new URLSearchParams(window.location.search);
  return params.has("logged");
}

const isLoggedIn = checkLoginStatus();
updateHeader(isLoggedIn ? connectedUser : newUser);

// * Search toggle functionality
function initializeSearchToggle() {
  const searchIcons = document.querySelectorAll(".search-icon");
  const searchRows = document.querySelectorAll(".header__row--search");

  searchIcons.forEach((searchIcon) => {
    searchIcon.addEventListener("click", (event) => {
      event.stopPropagation();
      toggleSearchBar();
    });
  });
}

function toggleSearchBar() {
  const searchRows = document.querySelectorAll(".header__row--search");
  const searchIcons = document.querySelectorAll(".search-icon");

  searchRows.forEach((searchRow) => {
    const isCurrentlyShown = searchRow.style.display === "flex";

    if (isCurrentlyShown) {
      searchRow.style.display = "none";

      searchIcons.forEach((icon) => {
        const paths = icon.querySelectorAll("path");
        paths.forEach((path) => {
          path.setAttribute("stroke", "black");
        });
      });
    } else {
      closeAllMenus();

      searchRow.style.display = "flex";

      searchIcons.forEach((icon) => {
        const paths = icon.querySelectorAll("path");
        paths.forEach((path) => {
          path.setAttribute("stroke", "#4138F2");
        });
      });
    }
  });
}

// * Mobile links functionality
function initializeMobileLinks() {
  const profileLinks = document.querySelectorAll(".header__profile");
  const cartLinks = document.querySelectorAll(".header__cart");

  profileLinks.forEach((profileLink) => {
    profileLink.addEventListener("click", (event) => {
      if (window.innerWidth < 1200) {
        event.stopPropagation();
      }
    });
  });

  cartLinks.forEach((cartLink) => {
    cartLink.addEventListener("click", (event) => {
      if (window.innerWidth < 1200) {
        event.stopPropagation();
      }
    });
  });
}

// * Utility function to preserve logged parameter
function preserveLoggedParam(originalUrl) {
  const currentParams = new URLSearchParams(window.location.search);
  const isLoggedIn = currentParams.has("logged");

  if (!isLoggedIn) {
    return originalUrl;
  }

  if (originalUrl.includes("?")) {
    return `${originalUrl}&logged`;
  } else {
    return `${originalUrl}?logged`;
  }
}

// * Initialize logged parameter preservation for all navigation links
function initializeLoggedParamPreservation() {
  const navigationLinks = document.querySelectorAll('a[href*="/?page="], a[href="/"]');

  navigationLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      const currentParams = new URLSearchParams(window.location.search);
      const isLoggedIn = currentParams.has("logged");

      if (isLoggedIn) {
        event.preventDefault();
        const originalHref = link.getAttribute("href");
        const newHref = preserveLoggedParam(originalHref);

        window.location.href = newHref;
      }
    });
  });
}
